<template>
<!--alx e-pos -->

    <div v-if="can('settings.edit')">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <router-link to="/transportation-organization" tag="li" class="breadcrumb-item"><a href="">{{i18n('Transportation organization')}}</a></router-link>
                <router-link to="/epos-services" tag="li" class="breadcrumb-item"><a href="">{{i18n("E-POS")}}</a>
                </router-link>
            </ol>
        </nav>

        <div class="base_box_hdr">
            <div class="base_box_ttl clearfix">
                <h1 class="title float-left pt-2">{{i18n("E-POS")}}</h1>
                <button v-if="can('settings.edit')" type="submit" class="btn base_btn solid_blue waves-effect waves-light float-right" @click="save()">{{i18n('Save and close')}}
                </button>
            </div>
        </div>

        <div class="base_box_main">
            <div class="base_box">
                <div class="base_box_cnt">
                    <h5>Параметры печати чека</h5>
                    <div class="responsive-table">
                        <table class="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th scope="col">Поле</th>
                                <th scope="col">Значение</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Название</td>
                                <td>
                                    <input type="text" class="form-control small_input w-auto" placeholder="-" :class="{'is-invalid': form.errors.has('company_name') }" v-model="form.company_name"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('company_name')">
                                        {{form.errors.get('company_name')}}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>Адрес</td>
                                <td>
                                    <input type="text" class="form-control small_input w-auto" placeholder="-" :class="{'is-invalid': form.errors.has('company_address') }" v-model="form.company_address"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('company_address')">
                                        {{form.errors.get('company_address')}}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>ИНН</td>
                                <td>
                                    <input type="text" class="form-control small_input w-auto" placeholder="-" :class="{'is-invalid': form.errors.has('company_inn') }" v-model="form.company_inn"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('company_inn')">
                                        {{form.errors.get('company_inn')}}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>ИКПУ междугородние билеты</td>
                                <td>
                                    <input type="text" class="form-control small_input w-auto" placeholder="-" :class="{'is-invalid': form.errors.has('class_code_domestic') }" v-model="form.class_code_domestic"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('class_code_domestic')">
                                        {{form.errors.get('class_code_domestic')}}
                                    </div>
                                </td>


                            </tr>
                            <tr>
                                <td>Код упаковки междугородние билеты</td>
                                <td>
                                    <input type="text" class="form-control small_input w-auto" placeholder="-" :class="{'is-invalid': form.errors.has('package_code_domestic') }" v-model="form.package_code_domestic"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('package_code_domestic')">
                                        {{form.errors.get('package_code_domestic')}}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td>ИКПУ международные билеты</td>
                                <td>
                                    <input type="text" class="form-control small_input w-auto" placeholder="-" :class="{'is-invalid': form.errors.has('class_code_international') }" v-model="form.class_code_international"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('class_code_international')">
                                        {{form.errors.get('class_code_international')}}
                                    </div>
                                </td>
                            </tr>
                            <tr>
                            <td>Код упаковки международные билеты</td>
                                <td>
                                    <input type="text" class="form-control small_input w-auto" placeholder="-" :class="{'is-invalid': form.errors.has('package_code_international') }" v-model="form.package_code_international"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('package_code_international')">
                                        {{form.errors.get('package_code_international')}}
                                    </div>
                                </td>
                            </tr>
                            <td>Ширина ленты</td>
                                <td>
                                    <input type="text" class="form-control small_input w-auto" placeholder="-" :class="{'is-invalid': form.errors.has('printer_size') }" v-model="form.printer_size"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('printer_size')">
                                        {{form.errors.get('printer_size')}}
                                    </div>
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                    <h5>Фискальные Модули</h5>
                    <div class="responsive-table">
                        <table class="table table-striped table-hover">
                            <thead>
                            <tr>
                                <th scope="col" class="w-80">ID устройства</th>
                                <th scope="col">IP адрес</th>
                            </tr>
                            </thead>
                            <tbody>

                            <tr v-for="model, key in modules_options">
                                <td>

                                    <input type="text" class="form-control small_input" :class="{'is-invalid': form.errors.has('modules.'+key+'.device_id')}"
                                           v-model="model.device_id" @keyup="handleRow(key)"/>
                                    <div class="invalid-feedback" v-if="form.errors.has('modules.'+key+'.device_id')">
                                        {{form.errors.get('modules.'+key+'.device_id')}}
                                    </div>

                                </td>
                                <td>

                                    <input type="text" class="form-control small_input" :class="{'is-invalid': form.errors.has('modules.'+key+'.device_ip')}"
                                           v-model="model.device_ip" @keyup="handleRow(key)" />
                                    <div class="invalid-feedback" v-if="form.errors.has('modules.'+key+'.device_ip')">
                                        {{form.errors.get('modules.'+key+'.device_ip')}}
                                    </div>

                                </td>
                            </tr>

                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormService from '../../services/FormService';
    export default {

        data() {
            return {
                form: new FormService({
                    company_name: null,
                    company_address: null,
                    company_inn: null,
                    class_code_domestic: null,
                    package_code_domestic: null,
                    class_code_international: null,
                    package_code_international: null,
                    printer_size: null,
                    modules: [],
                }),
                modules_options: [
                    {
                        device_id: null,
                        device_ip: null,
                    }
                ],
                isFilled: false,
                returnSettingsError: [],
            }
        },

        methods: {
            save(){
                this.form.modules = this.modules_options;
                this.submitForm();
            },
            submitForm(){
                this.form.submit('post', this.route('api.epos.store'))
                    .then(res => {
                        if (!res.errors) {
                            this.$router.push({name: 'epos-services'});
                            this.$notify({
                                type: 'success',
                                group: 'foo',
                                title: 'Успешно!!!',
                                text: 'Сохранено!'
                            });
                        } else {
                            console.log(res.errors);
                        }
                    })
            },
            handleRow(key){
                let model = this.modules_options;
                if(model.length > 0 &&
                    model[key].device_id && model[key].device_id.length > 0 &&
                    model[key].device_ip &&
                    model[key].device_ip.length > 0 &&
                    model.length === key + 1
                )
                    this.modules_options.push({
                        device_id: null,
                        device_ip: null
                    });

                if(model.length > 1 && !model[key].device_id && !model[key].device_ip) {
                    model.splice(key + 1, 1);
                    model.splice(key, 1);
                }
            },
            fillForm(data){
                this.form.company_name = data.company_name;
                this.form.company_address = data.company_address;
                this.form.company_inn = data.company_inn;
                this.form.class_code_domestic = data.class_code_domestic;
                this.form.package_code_domestic = data.package_code_domestic;
                this.form.class_code_international = data.class_code_international;
                this.form.package_code_international = data.package_code_international;
                this.form.printer_size = data.printer_size;
                this.modules_options = JSON.parse(data.modules) ? JSON.parse(data.modules) : this.modules_options;
            },
        },

        created() {
            this.$api.get('epos.data')
                .then(res => {
                    this.fillForm(res.data);
                });

            console.log(this.modules_options.length);
        },

    }
</script>

<style></style>
